import { FormattedMessage } from '@alltrails/shared/react-intl';
import LoadingSpinner from '../../../../components/shared/LoadingSpinner';
import Button from '@alltrails/shared/denali/components/Button';

const createReactClass = require('create-react-class');

const ShareModalDrawerQRCode = createReactClass({
  getInitialState() {
    return {
      loading: true
    };
  },
  downloadQRCode() {
    const qrcodeSrc = this.formatQRCodeSrc();
    // To set the name of the downloaded file we need to use this fetch-blob-a-click method
    fetch(`${qrcodeSrc}?disposition=attachment`).then(response => {
      response.blob().then(blob => {
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${this.props.shareObject.name}.png`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    });
  },
  formatQRCodeSrc() {
    const urlBase = `${location.protocol}//${location.host}`;
    return `${urlBase}/qrcode/${this.props.formatViewPath()}`;
  },
  onQRCodeImageLoad() {
    this.setState({ loading: false });
  },
  render() {
    const qrcodeSrc = this.formatQRCodeSrc();
    return (
      <div className="form-holder">
        <div style={{ display: this.state.loading ? 'block' : 'none' }} className="qrcode-placeholder">
          <LoadingSpinner />
        </div>
        <img style={{ display: this.state.loading ? 'none' : 'block' }} className="qrcode" src={qrcodeSrc} onLoad={this.onQRCodeImageLoad} />
        <p>
          <FormattedMessage defaultMessage="Download this QR code to quickly link others to the important information on this page. QR codes can be read by any device with the appropriate software. Use the smart phone or tablet to read the QR code." />
        </p>
        <div className="share-buttons">
          <Button
            text={<FormattedMessage defaultMessage="Download QR code" />}
            type="button"
            disabled={this.state.loading}
            size="md"
            onClick={this.downloadQRCode}
            variant="primary"
          />
        </div>
      </div>
    );
  }
});

export { ShareModalDrawerQRCode };
